import { render, staticRenderFns } from "./SlideTypeList.vue?vue&type=template&id=dd513600&scoped=true&"
import script from "./SlideTypeList.vue?vue&type=script&lang=js&"
export * from "./SlideTypeList.vue?vue&type=script&lang=js&"
import style0 from "./SlideTypeList.vue?vue&type=style&index=0&id=dd513600&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd513600",
  null
  
)

export default component.exports